//import Calculator from "./Calculator";
import FormContact from "./FormContact";
import Header from "./Header";
import ScrollHandler from "./ScrollHandler";
import Search from "./Search";
import SwiperHandler from "./SwiperHandler";

const app = {
  init: () => {
    console.log("NON");

    console.log(
      "Font Awesome Free 7.2.0 by @fontawesome - https://fontawesome.com",
    );
    console.log(
      "License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)",
    );
    console.log("Copyright 2026 Fonticons, Inc.");

    document.querySelector("html").classList.add("ready");

    Header.init();

    ScrollHandler.init();
    Search.init();
    SwiperHandler.init();

    FormContact.init();

    //Calculator.init();
  },
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", app.init)
  : app.init();
